import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Hook for real-time payment settings (fee percent, etc.)
 */
export const usePaymentSettings = () => {
  const [feePercent, setFeePercent] = useState(10);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'settings', 'payments'),
      (snap) => {
        if (snap.exists()) {
          setFeePercent(snap.data().feePercent ?? 10);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );

    return unsubscribe;
  }, []);

  return { feePercent, loading };
};
